export default __webpack_public_path__ + "static/media/not found.fe7690ba.png";